import { BlockProductFeedEntityHydrated, EntityId } from "@jackfruit/common"
import { nanoid } from "@reduxjs/toolkit"
import { createEntitySlice } from "../createEntitySlice"

const { slice: blockProductFeeds, selectors: blockProductFeedsSelectors } =
  createEntitySlice<BlockProductFeedEntityHydrated>("blockProductFeeds")

const blockProductFeedsFactory = (
  data: Partial<BlockProductFeedEntityHydrated>
): any => {
  return {
    id: nanoid(),
    productId: 0,
    templateId: 0,
    imageRegionsCount: 0,
    isLoadingUploadPhoto: false,
    isLoadingBuyNow: false,
    isReady: false,
    isLoading: true,
    hasError: false,
    imagery: {
      mobile: {
        featured: "",
        lifestyle: [],
      },
      desktop: {
        featured: "",
        lifestyle: [],
      },
    },
    error: "",
    ...data,
  }
}

type ImageryType = BlockProductFeedEntityHydrated["imagery"]

const blockProductFeedActions = {
  setProductId: (id: EntityId, productId: EntityId) => {
    return blockProductFeeds.actions.updateOne({
      id,
      changes: {
        productId,
      },
    })
  },
  setTemplateId: (id: EntityId, templateId: EntityId) => {
    return blockProductFeeds.actions.updateOne({
      id,
      changes: {
        templateId,
      },
    })
  },
  setImageRegionsCount: (id: EntityId, imageRegionsCount: number) => {
    return blockProductFeeds.actions.updateOne({
      id,
      changes: {
        imageRegionsCount,
      },
    })
  },
  setIsReady: (id: EntityId, isReady: boolean) => {
    return blockProductFeeds.actions.updateOne({
      id,
      changes: {
        isReady,
      },
    })
  },
  setIsLoading: (id: EntityId, isLoading: boolean) => {
    return blockProductFeeds.actions.updateOne({
      id,
      changes: {
        isLoading,
        isReady: false,
      },
    })
  },
  setIsLoadingUploadPhoto: (id: EntityId, isLoadingUploadPhoto: boolean) => {
    return blockProductFeeds.actions.updateOne({
      id,
      changes: {
        isLoadingUploadPhoto,
      },
    })
  },
  setIsLoadingBuyNow: (id: EntityId, isLoadingBuyNow: boolean) => {
    return blockProductFeeds.actions.updateOne({
      id,
      changes: {
        isLoadingBuyNow,
      },
    })
  },

  setImagery: (id: EntityId, imagery: ImageryType) => {
    return blockProductFeeds.actions.updateOne({
      id,
      changes: {
        imagery,
      },
    })
  },

  setHasError: (id: EntityId, hasError: boolean) => {
    return blockProductFeeds.actions.updateOne({
      id,
      changes: {
        hasError,
      },
    })
  },
  setError: (id: EntityId, error: string) => {
    return blockProductFeeds.actions.updateOne({
      id,
      changes: {
        error,
      },
    })
  },
}

export {
  blockProductFeedsFactory,
  blockProductFeeds,
  blockProductFeedsSelectors,
  blockProductFeedActions,
}
